import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import './B25-timeline-carousel.scss';

class B25TimelineCarousel extends Abstract {
	init() {
		this.setupObjectFit();

		const sliderEl = this.root.querySelector('.swiper-container');
		const prevEl = this.root.querySelector('.swiper-nav-prev');
		const nextEl = this.root.querySelector('.swiper-nav-next');
		const paginationEl = this.root.querySelector('.slider-timeline-pager');

		const sliderConfig = {
			speed: 500,
			autoplay: false,

			simulateTouch: false,
			preventInteractionOnTransition: true,

			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},

			navigation: {
				nextEl,
				prevEl,
				disabledClass: 'is-disabled',
			},
		};

		if (paginationEl) {
			sliderConfig.pagination = {
				type: 'timeline-pagination',
			};
		}

		this.slider = new Slider(sliderEl, sliderConfig);
	}
}

export default B25TimelineCarousel;
